<template>
  <div class="popbox show" style="display:block">
    <div class="popbox-overlay overlay">
      <div class="popbox-container">
        <!-- <a v-if="!guide" href="javascript:;" class="close" @click="close"></a> -->
        <div class="slideshow-container">
          <div class="mySlides img img1"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
// import FN from '@/utility/fn.js'
// import store from '../store'
// import PS from 'pubsub-js'
import '@/fuse/fuse.sdk'
export default {
  // props: {
  //   guide: Boolean,
  // },
  data() {
    return {
    //   ifram: this.$store.state.SDKComponent.iframe,
    //   index: 0
    }
  },
  // computed: {
  //   ...mapGetters(['SDKComponentMessage'])
  // },
  methods: {
    ...mapMutations(['UPDATE_IOS_GUIDE']),
    close(){
      this.UPDATE_IOS_GUIDE(false)
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
.popbox {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 600;
  color: rgba(255, 255, 255, 0);
  opacity: 1;
  visibility: hidden;
  transition: 0.3s ease;
  display: block;

  &.show {
    opacity: 1;
    visibility: visible;
  }

  .popbox-overlay {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: -webkit-box;
    display: -moz-box;
    -webkit-box-align: center;
    -moz-box-align: center;
    -webkit-box-pack: center;
    -moz-box-pack: center;
  }

  .popbox-container {
    width: 7rem;
    height: 12rem;
    padding: 0;
    background: rgba(255, 255, 255, 0);
    border-radius: 0.08rem;
    position: relative;
  }
}

.slideshow-container {
  height: 100%;
  width: 100%;
}

.mySlides {
  height: 100%;
  width: 100%;
}

.mySlides.img {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.img1 {
  background: url(../assets/img/guide/guide.png);
}



.popbox-container .close {
  position: absolute;
  width: 1rem;
  height: 1rem;
  bottom: -.2rem;
  left: calc(50% - 0.5rem);
  background-image: url(../assets/img/close.png);
  background-size: 0.54rem 0.54rem;
  background-repeat: no-repeat;
  background-position: center center;
  z-index: 999;
}
</style>